import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setExternalGuestHighlighted, setFullGuestList, setFullWeedingPassList, setGuestHighlighted, setGuestList, setSeatingPlan, 
  setWeedingPassList } from "../../../store/slices/group/groupSlice";
import { getFullExternalGuestList, getFullGuestList, getGuestList, getSeatingPlan, getWeedingPassList } 
from "../../../store/slices/group/thunks";
import { AddTable } from "./AddTable";
import { SeatingPlanDetails } from "./SeatingPlanDetails";
import styles from './SeatingPlanScreen.module.css'
import { SearchGuest } from "./SearchGuest";
import { downloadSeatingPlan } from "../../../store/slices/groupFiles/thunks";


export const SeatingPlanScreen = ({ groupFile }) => {
  const { seatingPlan, fullGuestList, fullWeedingPassList } = useSelector((state) => state.group);
  const [addTable, setAddTable] = useState(false);
  const [search, setSearch] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getGuestList(groupFile.code));

    return () => {
      dispatch(setGuestList([]));
    }
  }, [])


  useEffect(() => {
    dispatch(getFullGuestList(groupFile.code));

    return () => {
      dispatch(setFullGuestList([]));
    }
  }, [])

  useEffect(() => {
    dispatch(getWeedingPassList(groupFile.code));

    return () => {
      dispatch(setWeedingPassList([]));
    }
  }, [])

  useEffect(() => {
    dispatch(getFullExternalGuestList(groupFile.code));

    return () => {
      dispatch(setFullWeedingPassList([]));
    }
  }, [])

  useEffect(() => {
    dispatch(getSeatingPlan(groupFile.code));

    return () => {
      dispatch(setSeatingPlan([]));
    }
  }, [])

  useEffect(() => {

    return () => {
      dispatch(setGuestHighlighted(0));
      dispatch(setExternalGuestHighlighted(0));
    }
  }, [])


  return (
    <div className={`${styles.mainDiv}`} >
      <div className="row mb-6">
        <div className="col-6">
          <div className="row">
            <div className="col-auto">
              <div className={`${styles.title}`}>Plan De Mesas</div>
            </div>
            <div className="col-auto">
              <button className="btn btn-primary btn-info"
                onClick={() => setAddTable(true)}>Agregar Mesa</button>
            </div>
          </div>
        </div>
        <div className="col-3">
          <button className="btn btn-primary btn-info float-right"
            onClick={() => setSearch(true)}>Buscar Invitado</button>
        </div>
        <div className="col-3">
          <button className="btn btn-primary btn-info float-right"
            onClick={() => dispatch(downloadSeatingPlan(groupFile.id))}>Descargar</button>
        </div>
      </div>

      <SeatingPlanDetails seatingPlan={seatingPlan} code={groupFile.code} idGroupFile={groupFile.id} />
      <AddTable idGroupFile={groupFile.id} code={groupFile.code} isOpen={addTable} setIsOpen={setAddTable} />
      <SearchGuest fullGuestList={fullGuestList} fullWeedingPassList={fullWeedingPassList} code={groupFile.code} isOpen={search} setIsOpen={setSearch} />
    </div>
  )
}
